
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusSaleComparisonYearGrid extends Serenity.EntityGrid<ReportCusSaleComparisonRow, any> {
        protected getColumnsKey() { return ReportCusSaleComparisonYearColumns.columnsKey; }
        protected getDialogType() { return ReportCusSaleComparisonDialog; }
        protected getIdProperty() { return ReportCusSaleComparisonRow.idProperty; }
        protected getInsertPermission() { return ReportCusSaleComparisonRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportCusSaleComparisonRow.localTextPrefix; }
        protected getService() { return ReportCusSaleComparisonService.baseUrl; }

        public shopid : string;
        // public shopid : string;

        constructor(container: JQuery) {
            super(container);

            // this.shopid = QRreport.QRywcSpecRow.getLookup().itemById["122"].ShopId ?? null;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["ShopName"]);
            // groupingMixin.plugin.setDroppedGroups(["PosId"]);

        }
        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();


            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    new Slick.Aggregators.Sum('TwQtySold'),
                    new Slick.Aggregators.Sum('TwNetSalesExVat'),
                    new Slick.Aggregators.Sum('TwNetGpAmount'),
                    new Slick.Aggregators.Sum('LwQtySold'),
                    new Slick.Aggregators.Sum('LwNetSalesExVat'),
                    new Slick.Aggregators.Sum('LwNetGpAmount'),
                    new Slick.Aggregators.Sum('VarianceQtySold'),
                    new Slick.Aggregators.Sum('VarianceNetSalesExVat'),
                    new Slick.Aggregators.Sum('VarianceNetGpAmount')
                ]
            });
           

            return grid;
        }

        // private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
        //     // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
        //     // let columns = Object.keys(options.columnStyles)

            
        //     let descriptions: string[] = [];

        //     if(!Q.isEmptyOrNull(this.shopid)){
        //         descriptions.push("ระบุร้านค้า"+this.shopid)
        //     }else{
        //         descriptions.push("ไม่ระบุร้านค้า")
        //     }
                
           
            
        //     return [descriptions, gridColumns];
        // }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportCusSaleComparisonService.baseUrl + '/ListExcelYear',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            // let reportTitle = 'Sale Comparison Report'

            // // Max page width = 277 /// ข้อมูลหน้านี้ไม่พอ
            // let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
            //     0: { field: "ShopName", title: "ShopName", cellWidth: 16 ,overflow: 'linebreak'},
            //     1: { field: "Category1", title: "Category1", cellWidth: 15, halign: 'center' , overflow: 'linebreak' },
            //     2: { field: "Category2", title: "Category2", cellWidth: 24,overflow: 'linebreak'},
            //     3: { field: "Category3", title: "Category3", cellWidth: 24 ,overflow: 'linebreak'},
            //     4: { field: "PluCode", title: "PluCode", cellWidth: 24 ,overflow: 'linebreak'},
            //     5: { field: "PluDesc", title: "PluDesc", cellWidth: 24 ,overflow: 'linebreak'},
            //     6: { field: "BrandName", title: "BrandName", cellWidth: 15, halign: 'center' },
            //     7: { field: "SupplierId", title: "SupplierId", cellWidth: 15, halign: 'center' },
            //     8: { field: "SupPlierName", title: "SupPlierName", cellWidth: 25 ,overflow: 'linebreak'},

            //     9: { field: "TwQtySold", title: "TwQtySold", cellWidth: 20, halign: 'right' },
            //     10: { field: "TwNetSalesExVat", title: "TwNetSalesExVat", cellWidth: 20, halign: 'right'},
            //     11: { field: "TwNetGpAmount", title: "TwNetGpAmount", cellWidth: 15, halign: 'right' },
            //     12: { field: "TwNetGr", title: "TwNetGr", cellWidth: 10  },
            //     13: { field: "LwQtySold", title: "LwQtySold", cellWidth: 15, halign: 'right' },
            //     14: { field: "LwNetSalesExVat", title: "LwNetSalesExVat", cellWidth: 15, halign: 'right' },

            //     15: { field: "LwNetGpAmount", title: "LwNetGpAmount", cellWidth: 20, halign: 'right' },
            //     16: { field: "LwNetGr", title: "LwNetGr", cellWidth: 20, halign: 'right'},
            //     17: { field: "VarianceQtySold", title: "VarianceQtySold", cellWidth: 15, halign: 'right' },
            //     18: { field: "VarianceNetSalesExVat", title: "VarianceNetSalesExVat", cellWidth: 10  },
            //     19: { field: "VarianceNetGpAmount", title: "VarianceNetGpAmount", cellWidth: 15, halign: 'right' },
            //     20: { field: "VarianceNetGr", title: "VarianceNetGr", cellWidth: 15, halign: 'right' },
            //     21: { field: "PcVarianceQtySold", title: "PcVarianceQtySold", cellWidth: 15, halign: 'right' },
            //     22: { field: "PcVarianceNetSalesExVat", title: "PcVarianceNetSalesExVat", cellWidth: 15, halign: 'right' },
            //    
            // }

           

           

            // buttons.push(GeniuzPOS.Common.Helpers.Report1311PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 11,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         // head: ,
            //         headerStyles: {
            //             halign: 'center'
            //         },
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'center'
            //             }
            //         }
            //     }
            // }));

            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecReportCusSaleComparison/edit/122';
                        return false;
                    },
                }
            );
            return buttons;
        }
    }
}